import { Component } from 'react';
import { FeatureGroup } from 'hcmaps-leaflet';

class MapDrawFeatureGroup extends Component {
  // TODO: This component isn't necessary yet, but it will be
  // when we support deleting indvidual polygons.
  // Here is an example from appraiser: https://github.com/housecanary/appraisal/blob/bf8d8e75df20598e5ee70fbe58ab4f7057cd07bd/app/scripts/appraisal/neighborhood/components/MarketAreaFeatureGroup.jsx#L14
  render() {
    const { layers, editable } = this.props;
    if (layers && layers.length) {
      return (
        <FeatureGroup
          layers={layers}
          editable={editable}
          eventMap={{
            add: (e) =>
              editable
                ? e.target.invoke('enableEdit')
                : e.target.invoke('disableEdit')
          }}
        />
      );
    }
    return null;
  }
}

export default MapDrawFeatureGroup;
